<div mat-dialog-title style="float: left; width: 100%; padding: 0 0 1em 0">
  <div style="width: 100%; background-color: #002b43; float: left; color: white">
    <div style="width: 90%; float: left">
      <div style="margin: 1em">
        {{ 'quotation.messages.quotationUpdated' | translate }}
      </div>
    </div>
    <div style="width: 8%; float: left">
      <div style="margin-top: 1em">
        <img src="../../../assets/images/img_ok.svg" alt="" />
      </div>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div style="margin: 1em; color: grey; font-size: small; text-align: center">
    <p>{{ 'quotation.messages.quotationUpdateSuccess' | translate }}</p>
  </div>
  <div style="width: 30%; margin: auto">
    <div
      style="
        margin-top: 2em;
        margin-bottom: 2rem;
        border-radius: 50%;
        background-color: lightgray;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15%;
      "
    >
      <img
        src="../../../assets/images/img_ok.svg"
        alt=""
        style="object-fit: contain; max-width: 100%; max-height: 100%; border-radius: 50%"
      />
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div style="margin: 0 auto">
    <div style="padding-bottom: 2em">
      <button class="btn" mat-button mat-dialog-close>
        {{ 'quotation.messages.accept' | translate }}
      </button>
    </div>
  </div>
</div>
